import React from "react";
import img from '../scalabiltyassets/scaleimage.png';
import "./ScalabilityScalee.css";

export default function ScalabilityScalee() {
  return (
    <div id="scalability-scale" className="outsourcemainclass">
      <div className="left">
        <h2 className="heading">
          Powering Faster Delivery with DevOps Automation
        </h2>
        <p className="subheading">
        Empower your business with BastionEx’s DevOps Scalability services and build systems that grow seamlessly, perform reliably, and support long-term success.
        </p>
        <button>Book your free consultation</button>
      </div>
      <div className="right">
        <img src={img} alt="error" />
      </div>
    </div>
  );
}
